export default "__VITE_ASSET__84cbedc9__"